import React from 'react';
import ShippingSVG from './svg/ShippingSVG';
import ProcessingSVG from './svg/ProcessingSVG';
import CanceledSVG from './svg/CanceledSVG';
import CompletedSVG from './svg/CompletedSVG';
import DisabledSVG from './svg/DisabledSVG';
import { useTranslation } from 'react-i18next';
import EmailSVG from './svg/EmailSVG';
function mapOrderStatusLocalizable(orderStatus) {
    const { t } = useTranslation();
    switch (orderStatus) {
        case 'completed':
            return t('order.omsstatus.completed');
        case 'ready for pick up':
        case 'ready for pickup':
            return t('order.omsstatus.readyforpickup');
        case 'open':
            return t('order.omsstatus.open');
        case 'created':
        case 'new':
            return t('order.omsstatus.created');
        case 'processing':
            return t('order.omsstatus.processing');
        case 'delivery exception':
            return t('order.omsstatus.deliveryexception');
        case 'cancelled':
            return t('order.omsstatus.cancelled');
        case 'sent':
            return t('order.omsstatus.sent');
        case 'partially sent':
            return t('order.omsstatus.partiallysent');
        case 'partially delivered':
            return t('order.omsstatus.partiallydelivered');
        case 'delivered':
            return t('order.omsstatus.delivered');
        case 'undelivered':
            return t('order.omsstatus.undelivered');
        case 'partially cancelled':
            return t('order.omsstatus.partiallycancelled');
        case 'partially ready for pickup':
            return t('order.omsstatus.partiallyreadyforpickup');
        case 'partially undelivered':
            return t('order.omsstatus.partiallyundelivered');
        case 'lostintransit':
        case 'lost in transit':
            return t('order.omsstatus.lostintransit');
        case 'unable to deliver':
        case 'unabletodeliver':
        case 'undelivered':
            return t('order.omsstatus.undelivered');
        default:
            return orderStatus;
    }
}
const getTrackStatus = (status, isGiftCard = false) => {
    const svgOptions = {
        processing: { svg: React.createElement(ProcessingSVG, null) },
        sent: { svg: isGiftCard ? React.createElement(EmailSVG, null) : React.createElement(ShippingSVG, null) },
        sentDisabled: { svg: React.createElement(DisabledSVG, null) },
        sentPartially: { svg: React.createElement(ShippingSVG, null) },
        completed: { svg: React.createElement(CompletedSVG, null) },
        completedDisabled: { svg: React.createElement(DisabledSVG, null) },
        completedPartially: { svg: React.createElement(ProcessingSVG, null) },
        completedPickup: { svg: React.createElement(CompletedSVG, null) },
        canceled: { svg: React.createElement(CanceledSVG, null) },
        canceledPartially: { svg: React.createElement(CanceledSVG, null) },
    };
    switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
        case 'completed':
        case 'delivered':
            return {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completed],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent') },
                    { text: mapOrderStatusLocalizable('completed'), class: 'current' },
                ],
            };
        case 'sent':
        case 'shipped':
            return isGiftCard ? {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completed],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent') },
                    { text: mapOrderStatusLocalizable('completed'), class: 'current' },
                ],
            } : {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completedDisabled],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent'), class: 'current' },
                    { text: mapOrderStatusLocalizable('completed'), class: 'upcoming' },
                ],
            };
        case 'processing':
        case 'open':
        case 'new':
            return {
                svgs: [svgOptions.processing, svgOptions.sentDisabled, svgOptions.completedDisabled],
                labels: [
                    { text: mapOrderStatusLocalizable('processing'), class: 'current' },
                    { text: mapOrderStatusLocalizable('sent'), class: 'upcoming' },
                    { text: mapOrderStatusLocalizable('completed'), class: 'upcoming' },
                ],
            };
        case 'cancelled':
        case 'canceled':
            return {
                svgs: [svgOptions.canceled],
                labels: [{ text: mapOrderStatusLocalizable('cancelled'), class: 'current' }],
            };
        case 'partially sent':
            return {
                svgs: [svgOptions.processing, svgOptions.sentPartially, svgOptions.completedDisabled],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('partially sent'), class: 'current' },
                    { text: mapOrderStatusLocalizable('completed'), class: 'upcoming' },
                ],
            };
        case 'partially delivered':
            return {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completedPartially],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent') },
                    { text: mapOrderStatusLocalizable('partially delivered'), class: 'current' },
                ],
            };
        case 'partially canceled':
        case 'partially cancelled':
            return {
                svgs: [svgOptions.canceledPartially, svgOptions.sentDisabled, svgOptions.completedDisabled],
                labels: [
                    { text: mapOrderStatusLocalizable('partially cancelled'), class: 'current' },
                    { text: mapOrderStatusLocalizable('sent'), class: 'upcoming' },
                    { text: mapOrderStatusLocalizable('completed'), class: 'upcoming' },
                ],
            };
        case 'ready for pickup':
        case 'ready for pick up':
            return {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completedPickup],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent') },
                    { text: mapOrderStatusLocalizable('ready for pickup'), class: 'current' },
                ],
            };
        case 'partially ready for pickup':
        case 'partially ready for pick up':
        case 'partially read for pickup':
        case 'partially read for pick up':
            return {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completedPickup],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('sent') },
                    { text: mapOrderStatusLocalizable('partially ready for pickup'), class: 'current' },
                ],
            };
        case 'unable to deliver':
        case 'unabletodeliver':
        case 'undelivered':
            return {
                svgs: [svgOptions.canceled],
                labels: [{ text: mapOrderStatusLocalizable('unabletodeliver'), class: 'current' }],
            };
        case 'delivery exception':
        case 'lostintransit':
            return {
                svgs: [svgOptions.canceled],
                labels: [{ text: mapOrderStatusLocalizable('delivery exception'), class: 'current' }],
            };
        case 'partially undelivered':
            return {
                svgs: [svgOptions.processing, svgOptions.sent, svgOptions.completedPickup],
                labels: [
                    { text: mapOrderStatusLocalizable('processing') },
                    { text: mapOrderStatusLocalizable('partially undelivered') },
                    { text: mapOrderStatusLocalizable('completed'), class: 'current' },
                ],
            };
        default:
            return {
                svgs: [svgOptions.processing],
                labels: [{ text: mapOrderStatusLocalizable('processing'), class: 'current' }],
            };
    }
};
const OrderTrack = (props) => {
    var _a, _b;
    const trackStatus = getTrackStatus(props.status, props.isGiftCard || false);
    return (React.createElement("div", { className: "myfeed-order-track" },
        React.createElement("div", { className: trackStatus.svgs.length > 1 ? 'myfeed-order-track__graphic' : 'myfeed-order-track__graphic--centralized' }, (_a = trackStatus === null || trackStatus === void 0 ? void 0 : trackStatus.svgs) === null || _a === void 0 ? void 0 : _a.map((item, i) => {
            if (i === trackStatus.svgs.length - 1) {
                return React.createElement(React.Fragment, { key: i }, item.svg);
            }
            return (React.createElement(React.Fragment, { key: i },
                item.svg,
                React.createElement("hr", { className: "line" })));
        })),
        React.createElement("div", { className: trackStatus.svgs.length > 1 ? 'myfeed-order-track__legend' : 'myfeed-order-track__legend--centralized' }, (_b = trackStatus === null || trackStatus === void 0 ? void 0 : trackStatus.labels) === null || _b === void 0 ? void 0 : _b.map((label, i) => {
            if (i === trackStatus.labels.length - 1) {
                return (React.createElement("p", { key: label.text, className: label.class }, label.text));
            }
            return (React.createElement(React.Fragment, { key: label.text },
                React.createElement("p", { className: label.class }, label.text),
                React.createElement("div", null)));
        }))));
};
export default OrderTrack;
